/* SET STATE */
export const SET_STATE_PROVIDER = "SET_STATE_PROVIDER"

/* PROVIDERS */
export const GET_PROVIDERS = "GET_PROVIDERS"
export const GET_PROVIDERS_SUCCESS = "GET_PROVIDERS_SUCCESS"
export const GET_PROVIDERS_FAIL = "GET_PROVIDERS_FAIL"

/* PROVIDER */
export const GET_PROVIDER = "GET_PROVIDER"
export const GET_PROVIDER_SUCCESS = "GET_PROVIDER_SUCCESS"
export const GET_PROVIDER_FAIL = "GET_PROVIDER_FAIL"

/**
 * ADD PROVIDER
 */
 export const ADD_NEW_PROVIDER = "ADD_NEW_PROVIDER"
 export const ADD_PROVIDER_SUCCESS = "ADD_PROVIDER_SUCCESS"
 export const ADD_PROVIDER_FAIL = "ADD_PROVIDER_FAIL"

 /**
 * UPDATE PROVIDER
 */
export const UPDATE_PROVIDER = "UPDATE_PROVIDER"
export const UPDATE_PROVIDER_STATUS = "UPDATE_PROVIDER_STATUS"
export const UPDATE_PROVIDER_SUCCESS = "UPDATE_PROVIDER_SUCCESS"
export const UPDATE_PROVIDER_FAIL = "UPDATE_PROVIDER_FAIL"

/**
 * DELETE PROVIDER
 */
export const DELETE_PROVIDER = "DELETE_PROVIDER"
export const DELETE_PROVIDER_SUCCESS = "DELETE_PROVIDER_SUCCESS"
export const DELETE_PROVIDER_FAIL = "DELETE_PROVIDER_FAIL"
